export default __webpack_public_path__ + "static/media/InvestMobile.e7a6d199.png";